import { translatorf } from "Languages/Utility/translatorf";

const WinUPVC = {
  TakHalateh: 1,
  TwoHalatteh: 2,
  FaransaviTakHalateh: 3,
  FaransaviTowHalateh: 4,
  BalaBazsho: 5,
  Rail: 6,
  FolexVagon: 7,
  PaeenBazsho: 8,
  FaransaviChefti: 9,
  Akardeoni: 10,
  LiftAndSlide:11
};
const WinAluminum = {
  TakHalateh: 61,
  TwoHalatteh: 62,
  FaransaviTakHalateh: 63,
  FaransaviTowHalateh: 64,
  BalaBazsho: 65,
  Rail: 66,
  FolexVagon: 67,
  PaeenBazsho: 68,
  FaransaviChefti: 69,
  Akardeoni: 70,
  LiftAndSlide : 71,
  Pivot:72
};

const DoorAluminum = {
  TakHalateh: 101,
  TwoHalatteh: 102,
  FaransaviTakHalateh: 103,
  FaransaviTowHalateh: 104,
  Rail: 105,
  FolexVagon: 106,
  PaeenBazsho: 107,
  FaransaviChefti: 108,
  Akardeoni: 109,
  LiftAndSlide : 110,
  Pivot:111
};

const DoorUPVC = {
  TakHalateh: 31,
  TwoHalatteh: 32,
  FaransaviTakHalateh: 33,
  FaransaviTowHalateh: 34,
  Rail: 35,
  FolexVagon: 36,
  PaeenBazsho: 37,
  FaransaviChefti: 38,
  Akardeoni: 39,
  LiftAndSlide : 40
};

function GetIdPop(popList, IdStruct, doorOrWindow, typeName) {
  let idPop = 0;
  let msg = [translatorf('dropdown_not_defined')];
  let response;
  let IdStypePop = 0;

  if (doorOrWindow === "window" || doorOrWindow === 1) {
    if (IdStruct === 1) {
      //UPVC
      IdStypePop = WinUPVC[typeName];
    } else if (IdStruct === 2) {
      IdStypePop = WinAluminum[typeName];
    }
  } else if (doorOrWindow === "door" || doorOrWindow === 2) {
    if (IdStruct === 1) {
      //UPVC
      IdStypePop = DoorUPVC[typeName];
    } else if (IdStruct === 2) {
      IdStypePop = DoorAluminum[typeName];
    }
  }

  for (let item in popList) {
    if (popList[item].IdStypePopFitting === IdStypePop) {
      idPop = popList[item].Id;
      break;
    }
  }

  if (idPop !== 0) {
    response = idPop;
  } else {
    response = msg;
  }
  // console.log('idPop',idPop);
  return response;
}

export default GetIdPop;
